import DateTimeUtils from '@/lib/dateTimeUtils';

export default (value: Date) => {
    const date = new Date(value)  
    return DateTimeUtils.toShortDate(date);
} 